// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__zyMXG","actions":"style_actions__A+C3Q","actions_btn":"style_actions_btn__rCwH-"};